import {
  ReportReasonType,
  useUpdateReportReasonAsAdminMutation,
  ReportReason,
  useCreateReportReasonAsAdminMutation,
} from "../../../lib/apollo/graphql/generated";
import { useForm } from "../../../hooks/useForm";

export const useUpdateReportReasonModal = (
  onClose: () => void,
  reason?: ReportReason | null
) => {
  const [form, onChange] = useForm({
    id: reason?.id || "",
    reason: reason?.reason || "",
    active: reason?.active ? "ACTIVE" : "INACTIVE",
    type: reason?.type || ReportReasonType.CaregiverCommunity,
  });

  const isCreate = !reason;

  const [updateReportReason, { loading: isUpdateLoading }] =
    useUpdateReportReasonAsAdminMutation({
      onCompleted: () => {
        window.alert(`신고사유가 수정되었습니다`);
        onClose();
      },
      refetchQueries: ["GetReportReasonsDocument"],
    });

  const [createReportReaason, { loading: isCreateLoading }] =
    useCreateReportReasonAsAdminMutation({
      onCompleted: () => {
        window.alert("신고사유를 생성했습니다");
        onClose();
      },
      refetchQueries: ["GetReportReasonsDocument"],
    });

  const isSubmitDisabled =
    isCreateLoading ||
    isUpdateLoading ||
    !form.active ||
    !form.reason.trim() ||
    !form.type;

  const onSubmit = async (event?: React.FormEvent<HTMLFormElement>) => {
    event?.preventDefault();

    if (isSubmitDisabled) {
      return;
    }

    if (isCreate) {
      createReportReaason({
        variables: {
          reportReasonInput: {
            reason: form.reason.trim(),
            type: form.type as ReportReasonType,
            active: form.active === "ACTIVE",
          },
        },
      });
    } else {
      updateReportReason({
        variables: {
          reportReasonInput: {
            id: form.id ? form.id : "",
            reason: form.reason.trim(),
            type: form.type as ReportReasonType,
            active: form.active === "ACTIVE",
          },
        },
      });
    }
  };

  return {
    models: {
      form,
      isSubmitDisabled,
      loading: isUpdateLoading || isCreateLoading,
    },
    operations: {
      onChange,
      updateReportReason,
      onSubmit,
    },
  };
};
